import { Button } from "@/src/components/buttons";
import { FetchableList } from "@/src/components/fetchableLists";
import { Input } from "@/src/components/universalInput";
import { AiMessage } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { getUserId, uid } from "@/src/utils/utils";
import { useRef, useState } from "react";
import { FaChevronLeft } from "react-icons/fa6";
import { AiDescription } from "./aiDescription";
import AiMessageCard from "./aiMessageCard";
import AiAnswerCard from "@/src/data/aiAnswerCard";

function AiDiscussion({
  discussionId,
  onClose,
}: {
  discussionId: string;
  onClose: () => void;
}) {
  const [searchKey, setSearchKey] = useState<string>("");
  const [reload, setReload] = useState<number>(0);
  const [prompt, setPrompt] = useState<string>("");
  const buttonRef = useRef<HTMLDivElement>(null);
  const discussionRef = useRef<HTMLDivElement>(null);

  return (
    <AiDescription
      item={{
        id: "aiDiscussion",
        type: "card",
        title: "Discussion avec l'IA",
      }}
    >
      {/* <TasksOverlay key={uid()} currentRef={currentRef} />
      <TasksMouse currentRef={mouseRef} /> */}
      <div
        id="aiDiscussion"
        className=" c1 gap10   "
        style={{
          gridTemplateRows: "auto 1fr",
          background: "white",
          position: "relative",
          height: "100%",
          zIndex: 99999999,
        }}
      >
        <div className="drawer-header">
          {
            <div
              className="back-button"
              onClick={() => {
                onClose();
              }}
            >
              <FaChevronLeft size={18} />
            </div>
          }
          <h2 className="dialog-title">Discussion avec l&apos;IA</h2>
        </div>
        <div
          ref={discussionRef}
          className="c1 gap20 p20"
          style={{
            position: "relative",
            gridTemplateRows: "1fr auto",
            zIndex: 99999999,
            overflowY: "auto",
          }}
        >
          <FetchableList
            queryKey={["LoadAiMessages", searchKey, reload]}
            queryFn={async () => {
              let result = await apiFetch("aiMessages", "loadMany", {
                discussionId,
              });

              setTimeout(() => {
                discussionRef.current?.scrollTo({
                  top: discussionRef.current?.scrollHeight + 30,
                  behavior: "instant",
                });
              }, 10);
              return result;
            }}
          >
            {(data) => {
              return (
                <div>
                  <div className="c1 gap20">
                    {data?.map((aiMessage, index) => {
                      if (!aiMessage) return null;
                      return <AiMessageCard key={uid()} message={aiMessage} />;
                    })}
                    <AiAnswerCard
                      key={uid()}
                      discussionRef={discussionRef}
                      lastMessage={data?.[data.length - 1]}
                      discussionId={discussionId}
                      onFinish={async (fullValue) => {
                        let message: AiMessage = {
                          discussionId,
                          role: "assistant",
                          actionType: fullValue.type,
                          content: fullValue.content,
                          creator: getUserId(),
                          tasks: [],
                        };
                        await apiFetch("aiMessages", "addOne", {
                          message: message,
                        });
                        setReload((reload) => reload + 1);
                      }}
                    />
                  </div>
                </div>
              );
            }}
          </FetchableList>
          <div className="c1-auto aend gap10">
            <Input
              key={`${discussionId}-${reload}`}
              onEnter={async () => {
                buttonRef.current?.click();
              }}
              name={""}
              type="textarea"
              shouldFocus={true}
              placeholder="Que voulez-vous faire ?"
              value={prompt}
              onChange={(newValue) => {
                setPrompt(newValue || "");
              }}
            />
            <Button
              ref={buttonRef}
              onClick={async () => {
                let message: AiMessage = {
                  discussionId,
                  content: prompt,
                  creator: getUserId(),
                  role: "user",
                  actionType: "userMessage",
                  tasks: null,
                };
                message = await apiFetch("aiMessages", "addOne", {
                  message: message,
                  patientId: "patients:1752144557474vgw5rx4zi",
                });
                setPrompt("");
                setReload((reload) => reload + 1);
              }}
            >
              <div className="center" style={{ height: "40px" }}>
                Envoyer
              </div>
            </Button>
          </div>
        </div>
      </div>
    </AiDescription>
  );
}

export default AiDiscussion;
